<div class="flex flex-col gap-6 py-6">
  <div class="flex flex-col gap-4 rounded-2xl border border-shikenso-purple-base-12 p-4">
    <div>
      <h4 class="text-base font-medium">{{ 'pages.admin.eventAnalytics.users.mostActiveCard.title' | translate }}</h4>
      <p class="text-sm text-shikenso-purple-base-60">
        {{ 'pages.admin.eventAnalytics.users.mostActiveCard.subtitle' | translate }}
      </p>
    </div>

    <app-stacked-bars [segments]="mostActiveSegments()" [loading]="store.usersLoading$()" [showZeroBars]="true" />
  </div>

  <div class="flex flex-col gap-4 rounded-2xl border border-shikenso-purple-base-12 p-4">
    <div>
      <h4 class="text-base font-medium">{{ 'pages.admin.eventAnalytics.users.contentCreation.title' | translate }}</h4>
      <p class="text-sm text-shikenso-purple-base-60">
        {{
          'pages.admin.eventAnalytics.users.contentCreation.subtitle'
            | translate: { excludedCount: excludedUsersCount() }
        }}
      </p>
    </div>

    <div class="grid grid-cols-1 gap-6 min-[1280px]:grid-cols-2 min-[1640px]:grid-cols-3">
      <div class="flex flex-col items-center gap-3 min-[1280px]:items-start">
        <h5 class="text-sm font-medium">
          {{ 'pages.admin.eventAnalytics.users.contentCreation.campaignsCreated' | translate }}
        </h5>
        <app-circular-graph
          [data]="campaignsCreatedGraphData()"
          [colorMap]="rankColorMap"
          [nameOverrides]="campaignsCreatedNameOverrides()"
          [legendEntries]="campaignsCreatedRanking()"
          [legendValueBold]="true"
          [includeBonusInMainSeries]="true"
          [showPercentage]="false"
          [showTotal]="true"
          [totalCountCentered]="true"
          [loading]="store.usersLoading$()"
        />
      </div>

      <div class="flex flex-col items-center gap-3 min-[1280px]:items-start">
        <h5 class="text-sm font-medium">
          {{ 'pages.admin.eventAnalytics.users.contentCreation.reportsCreated' | translate }}
        </h5>
        <app-circular-graph
          [data]="reportsCreatedGraphData()"
          [colorMap]="rankColorMap"
          [nameOverrides]="reportsCreatedNameOverrides()"
          [legendEntries]="reportsCreatedRanking()"
          [legendValueBold]="true"
          [includeBonusInMainSeries]="true"
          [showPercentage]="false"
          [showTotal]="true"
          [totalCountCentered]="true"
          [loading]="store.usersLoading$()"
        />
      </div>

      <div
        class="col-span-1 flex flex-col items-center gap-3 min-[1280px]:col-span-2 min-[1640px]:col-span-1 min-[1640px]:items-stretch"
      >
        <h5 class="text-sm font-medium">
          {{ 'pages.admin.eventAnalytics.users.contentCreation.briefingsCreated' | translate }}
        </h5>
        <app-circular-graph
          [data]="briefingsCreatedGraphData()"
          [colorMap]="rankColorMap"
          [nameOverrides]="briefingsCreatedNameOverrides()"
          [legendEntries]="briefingsCreatedRanking()"
          [legendValueBold]="true"
          [includeBonusInMainSeries]="true"
          [showPercentage]="false"
          [showTotal]="true"
          [totalCountCentered]="true"
          [loading]="store.usersLoading$()"
        />
      </div>
    </div>
  </div>

  <div class="flex flex-col gap-4 rounded-2xl border border-shikenso-purple-base-12 p-4">
    <h4 class="text-base font-medium">{{ 'pages.admin.eventAnalytics.users.table.title' | translate }}</h4>

    <div class="admin-event-analytics-users-table-container">
      <app-datatable
        data-testid="admin-event-analytics-users-datatable"
        [rowData]="tableRows()"
        [columns]="tableColumns"
        [configurationInput]="tableConfiguration"
        [customColumnDef]="[{ name: 'completionPercentage', isSortable: true, template: completionPercentageColumn }]"
        [total]="total()"
        [loaderConfig]="tableLoaderConfig"
        [isInitialDataLoaded]="isTableDataLoaded()"
        [loadingData]="store.usersLoading$()"
      />
    </div>

    <ng-template #completionPercentageColumn let-row="row">
      <span>{{ row.completionPercentage }}</span>
    </ng-template>
  </div>
</div>
